import { CampanhaProdutoResponse } from "./CampanhaProdutoResponse";
import { CampanhaResumoResponse } from "./CampanhaResumoResponse";

export const BY_USUARIO_CAMPANHA = 'BY_USUARIO_CAMPANHA'
export const BY_RESUMO_CAMPANHA = 'BY_RESUMO_CAMPANHA'

export interface CampanhaProdutosState {
  byUsuarioCampanha: CampanhaProdutoResponse[];
  byResumoCampanha: CampanhaResumoResponse;
}

export interface ByUsuarioCampanhaAction {
  type: typeof BY_USUARIO_CAMPANHA,
  payload: CampanhaProdutoResponse[];
}

export interface ByResumoCampanhaAction {
  type: typeof BY_RESUMO_CAMPANHA,
  payload: CampanhaResumoResponse;
}

export type CampanhaProdutosActionTypes =
  ByUsuarioCampanhaAction
  | ByResumoCampanhaAction;